// Version : 0.0.1
// Author : NANDHAKUMAR
// LastEdit : NANDHAKUMAR
// Last ADD : REMOVE UNUSED FUNCTION
// MODFIED DATA : 02-09-2025

import { put, takeLatest, call, all } from 'redux-saga/effects';
import AutoLoanProposalActionTypes from './auto-loan-proposal.types';
import {
	searchMemberAutoLoan,
	addAutoLoanMemberBasic,
	fetchAutoLoanIndexList,
	getParticularAutoLoan,
	approveAutoLoan,
	revertAutoLoan,
	deleteAutoLoan,
	getdealerList,
	addAutoLoanMemberAddress,
	addAutoLoanMemberBank,
	addAutoLoanMemberImage,
	addAutoLoanMemberCoapplicant,
	addAutoLoanMemberCoapplicantDocument,
	addAutoLoanMemberVehicle,
	addAutoLoanMemberVehicleDocument,
	addAutoLoanMemberBusiness,
	addAutoLoanMemberBusinessImage,
	addAutoLoanMemberAutoLoanIndex,
	updateMemberAutoLoanIndexDetails,
	getPermantPincode,
	checkAutoLoanMandatoryDetails,
} from './auto-loan-proposal.services';
import {
	getAllDealerListFailure,
	getAllDealerListSuccess,
	getAllDealerListReponseChanged,
	createAutoLoanMemberAddressFailure,
	createAutoLoanMemberAddressSuccess,
	createAutoLoanMemberAddressResponseChanged,
	createAutoLoanMemberBankFailure,
	createAutoLoanMemberBankResponseChanged,
	createAutoLoanMemberImageResponseChanged,
	createAutoLoanMemberImageFailure,
	createAutoLoanMemberBankSuccess,
	createAutoLoanMemberImageSuccess,
	createAutoLoanMemberCoapplicantSuccess,
	createAutoLoanMemberCoapplicantFailure,
	createAutoLoanMemberCoapplicantResponseChanged,
	createAutoLoanMemberCoapplicantDocumentFailure,
	createAutoLoanMemberCoapplicantDocumentSuccess,
	createAutoLoanMemberCoapplicantDocumentResponseChanged,
	createAutoLoanMemberVehicleFailure,
	createAutoLoanMemberVehicleSuccess,
	createAutoLoanMemberVehicleResponseChanged,
	createAutoLoanMemberVehicleDocumentFailure,
	createAutoLoanMemberVehicleDocumentSuccess,
	createAutoLoanMemberVehicleDocumentResponseChanged,
	createAutoLoanMemberBusinessSuccess,
	createAutoLoanMemberBusinessFailure,
	createAutoLoanMemberBusinessResponseChanged,
	createAutoLoanMemberBusinessImageSuccess,
	createAutoLoanMemberBusinessImageFailure,
	createAutoLoanMemberBusinessImageResponseChanged,
	createAutoLoanMemberAutoLoanIndexFailure,
	createAutoLoanMemberAutoLoanIndexSuccess,
	createAutoLoanMemberAutoLoanIndexResponseChanged,
	deleteAutoLoanIndexResponseChanged,
	getPermantPincodeFailure,
	getPermantPincodeSuccess,
	getPermantPincodeResponseChanged,
	checkAutoLoanMandatoryDetailsFailure,
	checkAutoLoanMandatoryDetailsSuccess,
	checkAutoLoanMandatoryDetailsResponseChanged,
	updateAutoLoanMemberAutoLoanIndexFailure,
	updateAutoLoanMemberAutoLoanIndexSuccess,
	updateAutoLoanMemberAutoLoanIndexResponseChanged,
} from './auto-loan-proposal.action';
import { encryptData } from '../../../_common/enode-decode';
import AlertManager from '../../../../utils/alertManager';
import {
	approveAutoLoanProposalFailure,
	approveAutoLoanProposalResponseChanged,
	approveAutoLoanProposalSuccess,
	createAutoLoanMemberBasicFailure,
	createAutoLoanMemberBasicResponseChanged,
	createAutoLoanMemberBasicSucess,
	deleteAutoLoanIndexFailure,
	deleteAutoLoanIndexSuccess,
	fetchAutoLoanProposalListFailure,
	fetchAutoLoanProposalListResponseChanged,
	fetchAutoLoanProposalListSuccess,
	getAutoLoanProposalDetailFailure,
	getAutoLoanProposalDetailResponseChnaged,
	getAutoLoanProposalDetailSuccess,
	revertAutoLoanProposalFailure,
	revertAutoLoanProposalResponseChanged,
	revertAutoLoanProposalSuccess,
	searchMemberListFailure,
	searchMemberListResponseChanged,
	searchMemberListSuccess,
} from './auto-loan-proposal.action';

/** *********************  START SEARCH AUTO LOAN PROPOSAL  ******************** */
export function* searchMemberList({ payload }: any) {
	try {
		const key = 'SearchAutoLoanKey';
		const { databaseName, companyID, memberPhone, memberID, verifyType } = payload;
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			MemberPhone: memberPhone,
			MemberID: memberID,
			VerifyType: verifyType,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(searchMemberAutoLoan, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(searchMemberListFailure(responseData.data));
		} else {
			yield put(searchMemberListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(searchMemberListFailure(error));
	}
}

export function* resetMemberListChangedResponse() {
	yield put(searchMemberListResponseChanged());
}

export function* onSearchMemberAutoLoanDetails() {
	yield takeLatest(AutoLoanProposalActionTypes.SEARCH_MEMBER_LIST_START, searchMemberList);
}

export function* onSearchMemberAutoLoanResponseReset() {
	yield takeLatest(
		AutoLoanProposalActionTypes.SEARCH_MEMBER_LIST_RESPONSE_RESET,
		resetMemberListChangedResponse,
	);
}
/** *********************  END SEARCH AUTO LOAN PROPOSAL  ******************** */

/** *********************  START GET PARTICULAR AUTO LOAN INDEX  ******************** */
export function* getParticularAutoLoanDetail({ payload }: any) {
	try {
		const key = 'GetParticularAutoLoanProposalKey';
		const { databaseName, companyID, loanIndexID } = payload;
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			LoanIndexID: loanIndexID,
			loanIndexType: 'Auto',
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(getParticularAutoLoan, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getAutoLoanProposalDetailFailure(responseData.data));
		} else {
			yield put(getAutoLoanProposalDetailSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getAutoLoanProposalDetailFailure(error));
	}
}

export function* resetGetParticularListChangedResponse() {
	yield put(getAutoLoanProposalDetailResponseChnaged());
}

export function* onGetParticularAutoLoanDetails() {
	yield takeLatest(
		AutoLoanProposalActionTypes.GET_AUTO_LOAN_PROPOSAL_START,
		getParticularAutoLoanDetail,
	);
}

export function* onGetParticularAutoLoanResponseReset() {
	yield takeLatest(
		AutoLoanProposalActionTypes.GET_AUTO_LOAN_PROPOSAL_RESPONSE_RESET,
		resetGetParticularListChangedResponse,
	);
}
/** ********************* END GET PARTICULAR AUTO LOAN INDEX  ******************** */

/** *********************  START FETCH AUTO LOAN PROPOSAL  ******************** */
export function* fetchAutoLoanProposalList({ payload }: any) {
	try {
		const key = 'fetchAutoLoanProposalKey';
		const { databaseName, companyID, limit, centerID, branchID, inputSearch } = payload;
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			loanIndexType: 'Auto',
			Limit: limit,
			BranchID: branchID,
			CenterID: centerID,
			InputSearch: inputSearch,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchAutoLoanIndexList, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchAutoLoanProposalListFailure(responseData.data));
		} else {
			yield put(fetchAutoLoanProposalListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchAutoLoanProposalListFailure(error));
	}
}

export function* resetFetchMemberListChangedResponse() {
	yield put(fetchAutoLoanProposalListResponseChanged());
}

export function* onFetchMemberAutoLoan() {
	yield takeLatest(
		AutoLoanProposalActionTypes.FETCH_AUTO_LOAN_PROPOSAL_START,
		fetchAutoLoanProposalList,
	);
}

export function* onFetchMemberAutoLoanResponseReset() {
	yield takeLatest(
		AutoLoanProposalActionTypes.FETCH_AUTO_LOAN_PROPOSAL_RESPONSE_RESET,
		resetFetchMemberListChangedResponse,
	);
}

/** *********************  END FETCH AUTO LOAN PROPOSAL  ******************** */

/** *********************  START CREATE AUTO LOAN MEMBER BASIC PROPOSAL  ******************** */
export function* createMemberList({ payload }: any) {
	try {
		const key = 'AddAutoMemberBasicKey';
		const {
			databaseName,
			companyID,
			userID,
			mobileNumber,
			memberID,
			memberName,
			memberPhoto,
			alternativePhoneNumber,
			dateOfBirth,
			gender,
			maritalStatus,
			aadhaarNumber,
			panNumber,
			houseType,
			residentYear,
			spouseName,
			memberEducation,
			distanceFromBranch,
			memberCompanyID,
			memberCo,
			permanentPostOffice,
			currentPostOffice,
		} = payload;
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			UserID: userID,
			MemberPhone: mobileNumber,
			MemberID: memberID,
			MemberCo: memberCo,
			MemberName: memberName,
			MemberPhoto: memberPhoto,
			MemberDOB: dateOfBirth,
			MemberGender: gender,
			MartialStatus: maritalStatus,
			MemberAadarNum: aadhaarNumber,
			PanNumber: panNumber,
			HouseType: houseType,
			ResidentYear: residentYear,
			AlternativePhoneNumber: alternativePhoneNumber,
			SpouseName: spouseName,
			MemberEducation: memberEducation,
			DistanceFromBranch: distanceFromBranch,
			MemberCompanyID: memberCompanyID,
			PermanentPostOffice: permanentPostOffice,
			CurrentPostOffice: currentPostOffice,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(addAutoLoanMemberBasic, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(createAutoLoanMemberBasicFailure(responseData.data));
		} else {
			yield put(createAutoLoanMemberBasicSucess(responseData.data));
		}
	} catch (error) {
		yield put(createAutoLoanMemberBasicFailure(error));
	}
}

export function* resetCreateMemberListChangedResponse() {
	yield put(createAutoLoanMemberBasicResponseChanged());
}

export function* onCreateMemberAutoLoanDetails() {
	yield takeLatest(
		AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_BASIC_START,
		createMemberList,
	);
}

export function* onCreateMemberAutoLoanResponseReset() {
	yield takeLatest(
		AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_BASIC_RESPONSE_RESET,
		resetCreateMemberListChangedResponse,
	);
}
/** *********************  END CREATE AUTO LOAN MEMBER BASIC PROPOSAL  ******************** */

/** *********************  START CREATE AUTO LOAN MEMBER ADDRESS PROPOSAL  ******************** */
export function* createMemberAddress({ payload }: any) {
	try {
		const key = 'AddAutoMemberAddressKey';
		const {
			databaseName,
			companyID,
			userID,
			memberID,
			userName,
			permanentPincode,
			permanentStateName,
			permanentDistrictName,
			permanetCityName,
			permanentStreet,
			permanentAddress,
			currentPincode,
			currentStateName,
			currentDistrict,
			currentCityID,
			currentStreet,
			currentAddress,
			countryID,
			permanentPostOffice,
			currentPostOffice,
		} = payload;
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			UserID: userID,
			UserName: userName,
			MemberID: memberID,
			PermanentPincode: permanentPincode,
			PermanentCountry: countryID,
			PermanentStateName: permanentStateName,
			PermanentDistrictName: permanentDistrictName,
			PermanetCityName: permanetCityName,
			PermanentStreet: permanentStreet,
			PermanentAddress: permanentAddress,
			CurrentPincode: currentPincode,
			CurrentStateName: currentStateName,
			CurrentDistrict: currentDistrict,
			CurrentCityID: currentCityID,
			CurrentStreet: currentStreet,
			CurrentAddress: currentAddress,
			CurrentCountryID: countryID,
			PermanentPostOffice: permanentPostOffice,
			CurrentPostOffice: currentPostOffice,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(addAutoLoanMemberAddress, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(createAutoLoanMemberAddressFailure(responseData.data));
		} else {
			yield put(createAutoLoanMemberAddressSuccess(responseData.data));
		}
	} catch (error) {
		yield put(createAutoLoanMemberAddressFailure(error));
	}
}

export function* resetCreateMemberAddressChangedResponse() {
	yield put(createAutoLoanMemberAddressResponseChanged());
}

export function* onCreateMemberAddressAutoLoanDetails() {
	yield takeLatest(
		AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_ADDRESS_START,
		createMemberAddress,
	);
}

export function* onCreateMemberAddressAutoLoanResponseReset() {
	yield takeLatest(
		AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_ADDRESS_RESPONSE_RESET,
		resetCreateMemberAddressChangedResponse,
	);
}

/** *********************  END CREATE AUTO LOAN MEMBER ADDRESS PROPOSAL  ******************** */

/** *********************  START CREATE AUTO LOAN MEMBER BANK PROPOSAL  ******************** */
export function* createMemberBank({ payload }: any) {
	try {
		const key = 'AddAutoMemberBankKey';
		const {
			databaseName,
			companyID,
			userID,
			memberID,
			bankName,
			branchName,
			bankAccountNumber,
			reEnterAccountNumber,
			accountHolderName,
			ifscCode,
			userName,
			memberBankStatement,
			passbookImage,
		} = payload;
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			UserID: userID,
			UserName: userName,
			MemberID: memberID,
			BankName: bankName,
			BankBranchName: branchName,
			BankAccNumber: bankAccountNumber,
			ReBankAccNUmber: reEnterAccountNumber,
			AccHolderName: accountHolderName,
			IFSCCode: ifscCode,
			BankStatement: memberBankStatement,
			PassbookImage: passbookImage,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(addAutoLoanMemberBank, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(createAutoLoanMemberBankFailure(responseData.data));
		} else {
			yield put(createAutoLoanMemberBankSuccess(responseData.data));
		}
	} catch (error) {
		yield put(createAutoLoanMemberBankFailure(error));
	}
}

export function* resetCreateMemberBankChangedResponse() {
	yield put(createAutoLoanMemberBankResponseChanged());
}

export function* onCreateMemberBankAutoLoanDetails() {
	yield takeLatest(AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_BANK_START, createMemberBank);
}

export function* onCreateMemberBankAutoLoanResponseReset() {
	yield takeLatest(
		AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_BANK_RESPONSE_RESET,
		resetCreateMemberBankChangedResponse,
	);
}
/** *********************  END CREATE AUTO LOAN MEMBER BANK PROPOSAL  ******************** */

/** *********************  START CREATE AUTO LOAN MEMBER IMAGE PROPOSAL  ******************** */
export function* createMemberImage({ payload }: any) {
	try {
		const key = 'AddAutoMemberImageKey';
		const {
			databaseName,
			companyID,
			userID,
			memberID,
			houserImage1,
			houserImage2,
			aadharFrontImage,
			aadharBackImage,
			idProofImage,
			userName,
			passbookImage,
			addressFrontProofImage,
			addressBackProofImage,
			idProofBackImage,
			idProofFrontImage,
			gasBillImage,
			ebHouseTaxBillImage,
			memberBankStatement,
		} = payload;
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			UserID: userID,
			UserName: userName,
			MemberID: memberID,
			HouserImage1: houserImage1,
			HouserImage2: houserImage2,
			AadharFrontImage: aadharFrontImage,
			AadharBackImage: aadharBackImage,
			IdProofImage: idProofImage,
			PassbookImage: passbookImage,
			AddressFrontProofImage: addressFrontProofImage,
			AddressBackProofImage: addressBackProofImage,
			IdProofBackImage: idProofBackImage,
			IdProofFrontImage: idProofFrontImage,
			GasBillImage: gasBillImage,
			EbHouseTaxBillImage: ebHouseTaxBillImage,
			MemberBankStatement: memberBankStatement,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(addAutoLoanMemberImage, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(createAutoLoanMemberImageFailure(responseData.data));
		} else {
			yield put(createAutoLoanMemberImageSuccess(responseData.data));
		}
	} catch (error) {
		yield put(createAutoLoanMemberImageFailure(error));
	}
}

export function* resetCreateMemberImageChangedResponse() {
	yield put(createAutoLoanMemberImageResponseChanged());
}

export function* onCreateMemberImageAutoLoanDetails() {
	yield takeLatest(
		AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_IMAGE_START,
		createMemberImage,
	);
}

export function* onCreateMemberImageAutoLoanResponseReset() {
	yield takeLatest(
		AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_IMAGE_RESPONSE_RESET,
		resetCreateMemberImageChangedResponse,
	);
}

/** *********************  END CREATE AUTO LOAN MEMBER IMAGE PROPOSAL  ******************** */

/** *********************  START CREATE AUTO LOAN MEMBER COAPPLICANT PROPOSAL  ******************** */

export function* createMemberCoApplicant({ payload }: any) {
	try {
		const key = 'CreateAutoLoanCoApplicantBasicDetailsKey';
		const {
			databaseName,
			companyID,
			userID,
			memberID,
			coApplicantName,
			coApplicantDOB,
			coApplicantRelationship,
			coApplicantNumber,
			coApplicantAlternativeNumber,
			coApplicantDoorNo,
			coApplicantAddress,
			coApplicantCityID,
			coApplicantDistrict,
			coApplicantStateName,
			coApplicantCountryID,
			coApplicantPincode,
			coApplicantgender,
			coApplicantID,
		} = payload;
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			UserID: userID,
			MemberID: memberID,
			CoApplicantName: coApplicantName,
			CoApplicantDOB: coApplicantDOB,
			CoApplicantRelationship: coApplicantRelationship,
			CoApplicantNumber: coApplicantNumber,
			CoApplicantAlternativeNumber: coApplicantAlternativeNumber,
			CoApplicantDoorNo: coApplicantDoorNo,
			CoApplicantAddress: coApplicantAddress,
			CoApplicantCityID: coApplicantCityID,
			CoApplicantDistrict: coApplicantDistrict,
			CoApplicantStateID: coApplicantStateName,
			CoApplicantCountryID: coApplicantCountryID,
			CoApplicantPincode: coApplicantPincode,
			CoApplicantGender: coApplicantgender,
			CoApplicantID: coApplicantID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(addAutoLoanMemberCoapplicant, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(createAutoLoanMemberCoapplicantFailure(responseData.data));
		} else {
			yield put(createAutoLoanMemberCoapplicantSuccess(responseData.data));
		}
	} catch (error) {
		yield put(createAutoLoanMemberCoapplicantFailure(error));
	}
}

export function* resetCreateMemberCoApplicantChangedResponse() {
	yield put(createAutoLoanMemberCoapplicantResponseChanged());
}

export function* onCreateMemberCoApplicantAutoLoanDetails() {
	yield takeLatest(
		AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_COAPPLICANT_START,
		createMemberCoApplicant,
	);
}

export function* onCreateMemberCoApplicantAutoLoanResponseReset() {
	yield takeLatest(
		AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_COAPPLICANT_RESPONSE_RESET,
		resetCreateMemberCoApplicantChangedResponse,
	);
}

/** *********************  END CREATE AUTO LOAN MEMBER COAPPLICANT PROPOSAL  ******************** */

/** *********************  START CREATE AUTO LOAN MEMBER COAPPLICANT DOCUMENT PROPOSAL  ******************** */
export function* createMemberCoApplicantDocument({ payload }: any) {
	try {
		const key = 'CreateAutoLoanCoApplicantImagesKey';
		const {
			databaseName,
			companyID,
			userID,
			memberID,
			gasBillImg,
			ebBillImg,
			coApplicantAadharFrontImage,
			coApplicantAadharBackImage,
			coApplicantPhoto,
			coApplicantIdProofFrontImage,
			coApplicantIdProofBackImage,
			coApplicantID,
		} = payload;
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			UserID: userID,
			MemberID: memberID,
			GasBillImg: gasBillImg,
			EbBillImg: ebBillImg,
			CoApplicantAadharFrontImage: coApplicantAadharFrontImage,
			CoApplicantAadharBackImage: coApplicantAadharBackImage,
			CoApplicantPhoto: coApplicantPhoto,
			CoApplicantIdProofFrontImage: coApplicantIdProofFrontImage,
			CoApplicantIdProofBackImage: coApplicantIdProofBackImage,
			CoApplicantID: coApplicantID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(addAutoLoanMemberCoapplicantDocument, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(createAutoLoanMemberCoapplicantDocumentFailure(responseData.data));
		} else {
			yield put(createAutoLoanMemberCoapplicantDocumentSuccess(responseData.data));
		}
	} catch (error) {
		yield put(createAutoLoanMemberCoapplicantDocumentFailure(error));
	}
}

export function* resetCreateMemberCoApplicantDocumentChangedResponse() {
	yield put(createAutoLoanMemberCoapplicantDocumentResponseChanged());
}

export function* onCreateMemberCoApplicantDocumentAutoLoanDetails() {
	yield takeLatest(
		AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_COAPPLICANT_DOCUMENT_START,
		createMemberCoApplicantDocument,
	);
}

export function* onCreateMemberCoApplicantDocumentAutoLoanResponseReset() {
	yield takeLatest(
		AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_COAPPLICANT_DOCUMENT_RESPONSE_RESET,
		resetCreateMemberCoApplicantDocumentChangedResponse,
	);
}
/** *********************  END CREATE AUTO LOAN MEMBER COAPPLICANT DOCUMENT PROPOSAL  ******************** */

/** *********************  START CREATE AUTO LOAN MEMBER VEHICLE PROPOSAL  ******************** */
export function* createMemberVehicle({ payload }: any) {
	try {
		const key = 'CreateAutoLoanMemberVehicleKey';
		const {
			databaseName,
			companyID,
			userID,
			numberOfOwners,
			vehicleKeySurrender,
			dealerName,
			registrationState,
			registrationCity,
			registrationDate,
			registrationNumber,
			engineNumber,
			chassisNumber,
			vehicleCondtion,
			rcBookSurrenderType,
			vehicleColor,
			dealerID,
			insuranceType,
			insurancePeriod,
			insuranceFee,
			vechileID,
			vehicleType,
			vehicleOwnershipType,
			manufacturer,
			manufactureYear,
			vehicleMake,
			vehicleModel,
			memberID,
			rCBookSurrender,
			roadTax,
			vehicleFineAmount,
			vehicleRunningArea,
			nocSurrender,
		} = payload;
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			UserID: userID,
			MemberID: memberID,
			VehicleType: vehicleType,
			VehicleOwnershipType: vehicleOwnershipType,
			Manufacturer: manufacturer,
			ManufactureYear: manufactureYear,
			VehicleMake: vehicleMake,
			VehicleModel: vehicleModel,
			NumberOfOwners: numberOfOwners,
			VehicleKeySurrender: vehicleKeySurrender === 'YES' ? 1 : 0,
			VehicleCondtion: vehicleCondtion,
			RCBookSurrender: rCBookSurrender === 'YES' ? 1 : 0,
			DealerName: dealerName,
			RegistrationState: registrationState,
			RegistrationCity: registrationCity,
			RegistrationDate: registrationDate,
			RegistrationNumber: registrationNumber,
			RcBookSurrenderType: rcBookSurrenderType,
			EngineNumber: engineNumber,
			ChassisNumber: chassisNumber,
			VehicleColor: vehicleColor,
			DealerID: dealerID,
			InsuranceType: insuranceType,
			InsurancePeriod: insurancePeriod,
			InsuranceFee: insuranceFee,
			VechileID: vechileID,
			VehicleFineAmount: vehicleFineAmount,
			RoadTax: roadTax,
			VehicleRunningArea: vehicleRunningArea,
			NocSurrender: nocSurrender === 'YES' ? 1 : 0,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(addAutoLoanMemberVehicle, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(createAutoLoanMemberVehicleFailure(responseData.data));
		} else {
			yield put(createAutoLoanMemberVehicleSuccess(responseData.data));
		}
	} catch (error) {
		yield put(createAutoLoanMemberVehicleFailure(error));
	}
}

export function* resetCreateMemberVechileChangedResponse() {
	yield put(createAutoLoanMemberVehicleResponseChanged());
}

export function* onCreateMemberVehicleAutoLoanDetails() {
	yield takeLatest(
		AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_VEHICLE_START,
		createMemberVehicle,
	);
}

export function* onCreateMemberVehicleAutoLoanResponseReset() {
	yield takeLatest(
		AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_VEHICLE_RESPONSE_RESET,
		resetCreateMemberVechileChangedResponse,
	);
}

/** *********************  END CREATE AUTO LOAN MEMBER VEHICLE PROPOSAL  ******************** */

/** *********************  START CREATE AUTO LOAN MEMBER VEHICLE DOCUMENT PROPOSAL  ******************** */
export function* createMemberVehicleDocument({ payload }: any) {
	try {
		const key = 'CreateAutoLoanMemberVehicleDocumentKey';
		const {
			databaseName,
			companyID,
			userID,
			memberID,
			numberPlateImage,
			frontImage,
			leftSideImage,
			rightSideImage,
			backImage,
			kmReadingImage,
			rcBookFront,
			rcBookBack,
			keyImage,
			chassisNumberImage,
			engineNumberImage,
			toImage2,
			toImage1,
			nocImage1,
			nocImage2,
			vehicleID,
		} = payload;
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			UserID: userID,
			MemberID: memberID,
			NumberPlateImage: numberPlateImage,
			FrontImage: frontImage,
			LeftSideImage: leftSideImage,
			RightSideImage: rightSideImage,
			BackImage: backImage,
			KmReadingImage: kmReadingImage,
			RCBookFront: rcBookFront,
			RCBookBack: rcBookBack,
			KeyImage: keyImage,
			ChassisNumberImage: chassisNumberImage,
			EngineNumberImage: engineNumberImage,
			TOImage2: toImage2,
			TOImage1: toImage1,
			NocImage1: nocImage1,
			NocImage2: nocImage2,
			VehicleID: vehicleID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(addAutoLoanMemberVehicleDocument, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(createAutoLoanMemberVehicleDocumentFailure(responseData.data));
		} else {
			yield put(createAutoLoanMemberVehicleDocumentSuccess(responseData.data));
		}
	} catch (error) {
		yield put(createAutoLoanMemberVehicleDocumentFailure(error));
	}
}

export function* resetCreateVechileImgChangedResponse() {
	yield put(createAutoLoanMemberVehicleDocumentResponseChanged());
}

export function* onCreateMemberVehicleDocumentAutoLoanDetails() {
	yield takeLatest(
		AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_VEHICLE_DOCUMENT_START,
		createMemberVehicleDocument,
	);
}

export function* onCreateMemberVehicleDocumentAutoLoanResponseReset() {
	yield takeLatest(
		AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_VEHICLE_DOCUMENT_RESPONSE_RESET,
		resetCreateVechileImgChangedResponse,
	);
}

/** *********************  END CREATE AUTO LOAN MEMBER VEHICLE DOCUMENT PROPOSAL  ******************** */

/** *********************  START CREATE AUTO LOAN MEMBER BUSINESS PROPOSAL  ******************** */

export function* createMemberBusiness({ payload }: any) {
	try {
		const key = 'CreateAutoLoanMemberBusinessKey';
		const {
			databaseName,
			companyID,
			userID,
			businessPremises,
			nameOfCompany,
			designation,
			noOfYears,
			monthlyIncome,
			incomeType,
			montlyIncome,
			noOfFloors,
			nameOfBoard,
			stockValueOfBusiness,
			businessAddress,
			memberID,
			vehicleID,
			approximateSqft,
			businessRegisteredSince,
			rentalCost,
			fromYear,
			toYear,
			leaseAmount,
			borrowerType,
		} = payload;
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			UserID: userID,
			MemberID: memberID,
			BusinessPremises: businessPremises,
			NameOfCompany: nameOfCompany,
			Designation: designation,
			NoOfYears: noOfYears,
			MonthlyIncome: monthlyIncome,
			IncomeType: incomeType,
			VehicleID: vehicleID,
			BusinessAddress: businessAddress,
			StockValueOfBusiness: stockValueOfBusiness,
			NameOfBoard: nameOfBoard,
			MontlyIncome: montlyIncome,
			NoOfFloors: noOfFloors,
			ApproximateSqft: approximateSqft,
			BusinessRegisteredSince: businessRegisteredSince,
			RentalCost: rentalCost,
			FromYear: fromYear,
			ToYear: toYear,
			LeaseAmount: leaseAmount,
			BorrowerType: borrowerType,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(addAutoLoanMemberBusiness, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(createAutoLoanMemberBusinessFailure(responseData.data));
		} else {
			yield put(createAutoLoanMemberBusinessSuccess(responseData.data));
		}
	} catch (error) {
		yield put(createAutoLoanMemberBusinessFailure(error));
	}
}

export function* resetCreateMemberBusinessChangedResponse() {
	yield put(createAutoLoanMemberBusinessResponseChanged());
}

export function* onCreateMemberBusinessAutoLoanDetails() {
	yield takeLatest(
		AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_BUSINESS_START,
		createMemberBusiness,
	);
}

export function* onCreateMemberBusinessAutoLoanResponseReset() {
	yield takeLatest(
		AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_BUSINESS_RESPONSE_RESET,
		resetCreateMemberBusinessChangedResponse,
	);
}
/** *********************  END CREATE AUTO LOAN MEMBER BUSINESS PROPOSAL  ******************** */

/** *********************  START CREATE AUTO LOAN MEMBER BUSINESS IMAGE PROPOSAL  ******************** */
export function* createMemberBusinessImage({ payload }: any) {
	try {
		const key = 'CreateAutoLoanMemberBusinessImageKey';
		const {
			databaseName,
			companyID,
			userID,
			memberID,
			paySlip,
			idCardimage,
			empPassBookImage,
			stockImage,
			businessBoardImage,
			vehicleID,
			shopImage,
		} = payload;
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			UserID: userID,
			MemberID: memberID,
			PaySlip: paySlip,
			IdCardimage: idCardimage,
			PassBookImage: empPassBookImage,
			StockImage: stockImage,
			BusinessBoardImage: businessBoardImage,
			VehicleID: vehicleID,
			ShopImage: shopImage,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(addAutoLoanMemberBusinessImage, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(createAutoLoanMemberBusinessImageFailure(responseData.data));
		} else {
			yield put(createAutoLoanMemberBusinessImageSuccess(responseData.data));
		}
	} catch (error) {
		yield put(createAutoLoanMemberBusinessImageFailure(error));
	}
}

export function* resetCreateMemberBusinessImgChangedResponse() {
	yield put(createAutoLoanMemberBusinessImageResponseChanged());
}

export function* onCreateMemberBusinessImageAutoLoanDetails() {
	yield takeLatest(
		AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_BUSINESS_IMAGE_START,
		createMemberBusinessImage,
	);
}

export function* onCreateMemberBusinessImageAutoLoanResponseReset() {
	yield takeLatest(
		AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_BUSINESS_IMAGE_RESPONSE_RESET,
		resetCreateMemberBusinessImgChangedResponse,
	);
}
/** *********************  END CREATE AUTO LOAN MEMBER BUSINESS IMAGE PROPOSAL  ******************** */

/** *********************  START CREATE AUTO LOAN MEMBER AUTO LOAN INDEX PROPOSAL  ******************** */
export function* createMemberAutoLoanIndex({ payload }: any) {
	try {
		const key = 'CreateAutoLoanMemberAutoLoanIndexKey';
		const {
			databaseName,
			companyID,
			userID,
			memberID,
			branchID,
			centerID,
			groupID,
			memberUniqueID,
			rateOfInterest,
			roadTax,
			officeDocCharge,
			dealerBrokerageFees,
			staffIncentiveFees,
			docChargeFees,
			loanProposalDate,
			loanProductID,
			centerOfficerID,
			loanIndexID,
			loanType,
			centerName,
			loanTypeID,
			userName,
			userAccessBranchID,
			meetupLocation,
			meetUpTime,
			meetingDay,
			vehiclePrice,
			downPayment,
			loanAmount,
			loanTenure,
			productAmount,
			noOfInstalment,
			loanStartDate,
			loanEndDate,
			principalAmount,
			productInterest,
			productInterestAmount,
			fixedEMIAmount,
			memberAmount,
			docCharges,
			processingFeePercentage,
			igstPercentage,
			cgstPercentage,
			sgst,
			sgstPercentage,
			verificationFee,
			hpFee,
			insuranceFeePercentage,
			processingFee,
			igst,
			cgst,
			insuranceFee,
			eligibleLoanAmount,
			toDealerSendOption,
			toCustomerSendOption,
			toDealerTotalAmount,
			toCustomerTotalAmount,
		} = payload;
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			UserID: userID,
			MemberID: memberID,
			BranchID: branchID,
			CenterID: centerID,
			GroupID: groupID,
			MemberUniqueID: memberUniqueID,
			RateOfInterest: rateOfInterest,
			RoadTax: roadTax,
			OfficeDocCharge: officeDocCharge,
			DealerBrokerageFees: dealerBrokerageFees,
			StaffIncentiveFees: staffIncentiveFees,
			DocChargeFees: docChargeFees,
			LoanProposalDate: loanProposalDate,
			LoanProductID: loanProductID,
			CenterOfficerID: centerOfficerID,
			LoanIndexID: loanIndexID,
			LoanType: loanType,
			CenterName: centerName,
			LoanTypeID: loanTypeID,
			UserName: userName,
			UserAccessBranchID: userAccessBranchID,
			MeetupLocation: meetupLocation,
			MeetingDay: meetingDay,
			MeetUpTime: meetUpTime,
			VehiclePrice: vehiclePrice,
			DownPayment: downPayment,
			LoanAmount: loanAmount,
			LoanTenure: loanTenure,
			ProductAmount: productAmount,
			NoOfInstalment: noOfInstalment,
			LoanStartDate: loanStartDate,
			LoanEndDate: loanEndDate,
			PrincipalAmount: principalAmount,
			ProductInterest: productInterest,
			ProductInterestAmount: productInterestAmount,
			FixedEMIAmount: fixedEMIAmount,
			MemberAmount: memberAmount ?? '0',
			ProdcutDocCharges: docCharges ?? '0',
			ProcessingFeePercentage: processingFeePercentage ?? '0',
			ProcessingFee: processingFee ?? '0',
			IgstPercentage: igstPercentage ?? '0',
			Igst: igst ?? '0',
			CgstPercentage: cgstPercentage ?? '0',
			Cgst: cgst ?? '0',
			Sgst: sgst ?? '0',
			SgstPercentage: sgstPercentage ?? '0',
			VerificationFee: verificationFee ?? '0',
			HpFee: hpFee ?? '0',
			InsuranceFeePercentage: insuranceFeePercentage ?? '0',
			InsuranceFee: insuranceFee ?? '0',
			EligibleLoanAmount: eligibleLoanAmount ?? '0',
			ToDealerSendOption: toDealerSendOption,
			ToCustomerSendOption: toCustomerSendOption,
			ToDealerTotalAmount: toDealerTotalAmount,
			ToCustomerTotalAmount: toCustomerTotalAmount,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(addAutoLoanMemberAutoLoanIndex, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(createAutoLoanMemberAutoLoanIndexFailure(responseData.data));
		} else {
			yield put(createAutoLoanMemberAutoLoanIndexSuccess(responseData.data));
		}
	} catch (error) {
		yield put(createAutoLoanMemberAutoLoanIndexFailure(error));
	}
}

export function* resetCreateAutoLoanIndexChangedResponse() {
	yield put(createAutoLoanMemberAutoLoanIndexResponseChanged());
}

export function* onCreateMemberAutoLoanIndexDetails() {
	yield takeLatest(
		AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_AUTO_LOAN_INDEX_START,
		createMemberAutoLoanIndex,
	);
}

export function* onCreateMemberAutoLoanIndexResponseReset() {
	yield takeLatest(
		AutoLoanProposalActionTypes.ADD_AUTO_LOAN_MEMBER_AUTO_LOAN_INDEX_RESPONSE_RESET,
		resetCreateAutoLoanIndexChangedResponse,
	);
}
/** *********************  END CREATE AUTO LOAN MEMBER AUTO LOAN INDEX PROPOSAL  ******************** */

/** *********************  START CREATE AUTO LOAN MEMBER AUTO LOAN INDEX PROPOSAL  ******************** */
export function* updateMemberAutoLoanIndex({ payload }: any) {
	try {
		const key = 'UpdateAutoLoanMemberAutoLoanIndexKey';
		const {
			databaseName,
			companyID,
			userID,
			memberID,
			branchID,
			centerID,
			groupID,
			memberUniqueID,
			rateOfInterest,
			roadTax,
			officeDocCharge,
			dealerBrokerageFees,
			staffIncentiveFees,
			docChargeFees,
			loanProposalDate,
			loanProductID,
			centerOfficerID,
			loanIndexID,
			loanType,
			centerName,
			loanTypeID,
			userName,
			userAccessBranchID,
			meetupLocation,
			meetUpTime,
			meetingDay,
			vehiclePrice,
			downPayment,
			loanAmount,
			loanTenure,
			productAmount,
			noOfInstalment,
			loanStartDate,
			loanEndDate,
			principalAmount,
			productInterest,
			productInterestAmount,
			fixedEMIAmount,
			memberAmount,
			docCharges,
			processingFeePercentage,
			igstPercentage,
			cgstPercentage,
			sgst,
			sgstPercentage,
			verificationFee,
			hpFee,
			insuranceFeePercentage,
			processingFee,
			igst,
			cgst,
			insuranceFee,
			eligibleLoanAmount,
			toDealerSendOption,
			toCustomerSendOption,
			toDealerTotalAmount,
			toCustomerTotalAmount,
		} = payload;
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
			UserID: userID,
			MemberID: memberID,
			BranchID: branchID,
			CenterID: centerID,
			GroupID: groupID,
			MemberUniqueID: memberUniqueID,
			RateOfInterest: rateOfInterest,
			RoadTax: roadTax,
			OfficeDocCharge: officeDocCharge,
			DealerBrokerageFees: dealerBrokerageFees,
			StaffIncentiveFees: staffIncentiveFees,
			DocChargeFees: docChargeFees,
			LoanProposalDate: loanProposalDate,
			LoanProductID: loanProductID,
			CenterOfficerID: centerOfficerID,
			LoanIndexID: loanIndexID,
			LoanType: loanType,
			CenterName: centerName,
			LoanTypeID: loanTypeID,
			UserName: userName,
			UserAccessBranchID: userAccessBranchID,
			MeetupLocation: meetupLocation,
			MeetingDay: meetingDay,
			MeetUpTime: meetUpTime,
			VehiclePrice: vehiclePrice,
			DownPayment: downPayment,
			LoanAmount: loanAmount,
			LoanTenure: loanTenure,
			ProductAmount: productAmount,
			NoOfInstalment: noOfInstalment,
			LoanStartDate: loanStartDate,
			LoanEndDate: loanEndDate,
			PrincipalAmount: principalAmount,
			ProcessingFee: processingFee,
			ProductInterest: productInterest,
			ProductInterestAmount: productInterestAmount,
			FixedEMIAmount: fixedEMIAmount,
			MemberAmount: memberAmount ?? '0',
			ProdcutDocCharges: docCharges ?? '0',
			ProcessingFeePercentage: processingFeePercentage ?? '0',
			IgstPercentage: igstPercentage ?? '0',
			CgstPercentage: cgstPercentage ?? '0',
			Sgst: sgst ?? '0',
			SgstPercentage: sgstPercentage ?? '0',
			VerificationFee: verificationFee ?? '0',
			HpFee: hpFee ?? '0',
			InsuranceFeePercentage: insuranceFeePercentage ?? '0',
			InsuranceFee: insuranceFee ?? '0',
			IGST: igst ?? '0',
			CGST: cgst ?? '0',
			EligibleLoanAmount: eligibleLoanAmount ?? '0',
			ToCustomerSendOption: toCustomerSendOption,
			ToDealerSendOption: toDealerSendOption,
			ToDealerTotalAmount: toDealerTotalAmount,
			ToCustomerTotalAmount: toCustomerTotalAmount,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(updateMemberAutoLoanIndexDetails, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateAutoLoanMemberAutoLoanIndexFailure(responseData.data));
		} else {
			yield put(updateAutoLoanMemberAutoLoanIndexSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateAutoLoanMemberAutoLoanIndexFailure(error));
	}
}

export function* resetUpdateAutoLoanIndexChangedResponse() {
	yield put(updateAutoLoanMemberAutoLoanIndexResponseChanged());
}

export function* onUpdateMemberAutoLoanIndexDetails() {
	yield takeLatest(
		AutoLoanProposalActionTypes.UPDATE_AUTO_LOAN_MEMBER_AUTO_LOAN_INDEX_START,
		updateMemberAutoLoanIndex,
	);
}

export function* onUpdataeMemberAutoLoanIndexResponseReset() {
	yield takeLatest(
		AutoLoanProposalActionTypes.UPDATE_AUTO_LOAN_MEMBER_AUTO_LOAN_INDEX_RESPONSE_RESET,
		resetUpdateAutoLoanIndexChangedResponse,
	);
}
/** *********************  END CREATE AUTO LOAN MEMBER AUTO LOAN INDEX PROPOSAL  ******************** */

/** *********************  START APPROVE AUTO LOAN PROPOSAL  ******************** */
export function* approveAutoLoanMemberList({ payload }: any) {
	try {
		const key = 'approveAutoLoanProposalKey';
		const {
			userID,
			databaseName,
			companyID,
			loanIndexID,
			appraisalNotes,
			memberStatus,
			memberID,
			groupID,
			centerID,
		} = payload;
		const jsonData = {
			UserID: userID,
			DatabaseName: databaseName,
			CompanyID: companyID,
			LoanIndexID: loanIndexID,
			AppraisalNotes: appraisalNotes,
			MemberStatus: memberStatus,
			MemberID: memberID,
			GroupID: groupID,
			CenterID: centerID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(approveAutoLoan, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(approveAutoLoanProposalFailure(responseData.data));
		} else {
			yield put(approveAutoLoanProposalSuccess(responseData.data));
		}
	} catch (error) {
		yield put(approveAutoLoanProposalFailure(error));
	}
}

export function* resetApproveAutoLoanMemberListChangedResponse() {
	yield put(approveAutoLoanProposalResponseChanged());
}

export function* onApproveMemberAutoLoan() {
	yield takeLatest(
		AutoLoanProposalActionTypes.APPROVE_AUTO_LOAN_PROPOSAL_START,
		approveAutoLoanMemberList,
	);
}

export function* onApproveMemberAutoLoanResponseReset() {
	yield takeLatest(
		AutoLoanProposalActionTypes.APPROVE_AUTO_LOAN_PROPODAL_RESPONSE_RESET,
		resetApproveAutoLoanMemberListChangedResponse,
	);
}
/** *********************  END approve AUTO LOAN PROPOSAL  ******************** */

/** *********************  START REVERT AUTO LOAN PROPOSAL  ******************** */
export function* revertAutoLoanMemberList({ payload }: any) {
	try {
		const key = 'revertAutoLoanProposalKey';
		const { userID, databaseName, companyID, loanIndexID } = payload;
		const jsonData = {
			UserID: userID,
			DatabaseName: databaseName,
			companyID: companyID,
			LoanIndexID: loanIndexID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(revertAutoLoan, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(revertAutoLoanProposalFailure(responseData.data));
		} else {
			yield put(revertAutoLoanProposalSuccess(responseData.data));
		}
	} catch (error) {
		yield put(revertAutoLoanProposalFailure(error));
	}
}

export function* resetRevertAutoLoanMemberListChangedResponse() {
	yield put(revertAutoLoanProposalResponseChanged());
}

export function* onRevertMemberAutoLoan() {
	yield takeLatest(
		AutoLoanProposalActionTypes.REVERT_AUTO_LOAN_PROPOSAL_START,
		revertAutoLoanMemberList,
	);
}

export function* onrevertMemberAutoLoanResponseReset() {
	yield takeLatest(
		AutoLoanProposalActionTypes.REVERT_AUTO_LOAN_PROPODAL_RESPONSE_RESET,
		resetRevertAutoLoanMemberListChangedResponse,
	);
}
/** *********************  END REVERT AUTO LOAN PROPOSAL  ******************** */

/** *********************  START DELETE AUTO LOAN PROPOSAL  ******************** */
export function* deleteAutoLoanMemberList({ payload }: any) {
	try {
		const key = 'deleteAutoLoanProposalKey';
		const { userID, databaseName, companyID, loanIndexID, userName } = payload;
		const jsonData = {
			UserID: userID,
			UserName: userName,
			DatabaseName: databaseName,
			companyID: companyID,
			LoanIndexID: loanIndexID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(deleteAutoLoan, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(deleteAutoLoanIndexFailure(responseData.data));
		} else {
			yield put(deleteAutoLoanIndexSuccess(responseData.data));
		}
	} catch (error) {
		yield put(deleteAutoLoanIndexFailure(error));
	}
}

export function* resetDeleteAutoLoanMemberListChangedResponse() {
	yield put(deleteAutoLoanIndexResponseChanged());
}

export function* onDeleteMemberAutoLoan() {
	yield takeLatest(
		AutoLoanProposalActionTypes.DELETE_AUTO_LOAN_PROPOSAL_START,
		deleteAutoLoanMemberList,
	);
}

export function* ondeleteMemberAutoLoanResponseReset() {
	yield takeLatest(
		AutoLoanProposalActionTypes.DELETE_AUTO_LOAN_PROPODAL_RESPONSE_RESET,
		resetDeleteAutoLoanMemberListChangedResponse,
	);
}
/** *********************  END DELETE AUTO LOAN PROPOSAL  ******************** */

/** ********************* START GET DEALER LIST DETAIL ******************** */
export function* getAllDealerList({ payload }: any) {
	try {
		const key = 'GetDealerListKey';
		const { databaseName, companyID } = payload;
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(getdealerList, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getAllDealerListFailure(responseData.data));
		} else {
			yield put(getAllDealerListSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getAllDealerListFailure(error));
	}
}

export function* resetDealerList() {
	yield put(getAllDealerListReponseChanged());
}

export function* onGetAllDealerList() {
	yield takeLatest(AutoLoanProposalActionTypes.GET_ALL_DEALER_LIST_START, getAllDealerList);
}

export function* onGetAllDealerListReset() {
	yield takeLatest(
		AutoLoanProposalActionTypes.GET_ALL_DEALER_LIST_RESPONSE_RESET,
		resetDealerList,
	);
}
/** *********************  END GET DEALER LIST PROPOSAL ******************** */

/** ********************* START GET PERMANT PINCODE DETAIL ******************** */
export function* getPermantPincodeList({ payload }: any) {
	try {
		const { pincode, state } = payload;
		const key = 'FetchPincodeListKey';
		const jsonData = {
			Pincode: pincode,
			State: state,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(getPermantPincode, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(getPermantPincodeFailure(responseData.data));
		} else {
			yield put(getPermantPincodeSuccess(responseData.data));
		}
	} catch (error) {
		yield put(getPermantPincodeFailure(error));
	}
}

export function* resetPermantPincodeList() {
	yield put(getPermantPincodeResponseChanged());
}

export function* onGetPermantPincodeList() {
	yield takeLatest(AutoLoanProposalActionTypes.GET_PERMANT_PINCODE_START, getPermantPincodeList);
}

export function* onGetPermantPincodeListReset() {
	yield takeLatest(
		AutoLoanProposalActionTypes.GET_PERMANT_PINCODE_RESPONSE_RESET,
		resetPermantPincodeList,
	);
}
/** *********************  END GET DEALER LIST PROPOSAL ******************** */

/** ********************* START CHECK AUTO LOAN MANDATORY DETAILS ******************** */
export function* checkAutoLoanMandatory({ payload }: any) {
	try {
		const { databaseName, companyID } = payload;
		const key = 'AutoLoanMandatoryFieldsKey';
		const jsonData = {
			DatabaseName: databaseName,
			CompanyID: companyID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(checkAutoLoanMandatoryDetails, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(checkAutoLoanMandatoryDetailsFailure(responseData.data));
		} else {
			yield put(checkAutoLoanMandatoryDetailsSuccess(responseData.data));
		}
	} catch (error) {
		yield put(checkAutoLoanMandatoryDetailsFailure(error));
	}
}

export function* resetCheckAutoLoanMandatoryResponse() {
	yield put(checkAutoLoanMandatoryDetailsResponseChanged());
}

export function* onCheckAutoLoanMandatory() {
	yield takeLatest(
		AutoLoanProposalActionTypes.CHECK_AUTOLOAN_MANDATORY_DETAILS_START,
		checkAutoLoanMandatory,
	);
}

export function* onCheckAutoLoanMandatoryResponseReset() {
	yield takeLatest(
		AutoLoanProposalActionTypes.CHECK_AUTOLOAN_MANDATORY_DETAILS_RESPONSE_RESET,
		resetCheckAutoLoanMandatoryResponse,
	);
}
/** *********************  END CHECK AUTO LOAN MANDATORY DETAILS ******************** */

export function* autoLoanProposalSaga() {
	yield all([
		call(onSearchMemberAutoLoanDetails),
		call(onSearchMemberAutoLoanResponseReset),
		call(onCreateMemberAddressAutoLoanDetails),
		call(onCreateMemberAddressAutoLoanResponseReset),
		call(onCreateMemberBankAutoLoanDetails),
		call(onCreateMemberBankAutoLoanResponseReset),
		call(onCreateMemberImageAutoLoanDetails),
		call(onCreateMemberImageAutoLoanResponseReset),
		call(onCreateMemberCoApplicantAutoLoanDetails),
		call(onCreateMemberCoApplicantAutoLoanResponseReset),
		call(onCreateMemberCoApplicantDocumentAutoLoanDetails),
		call(onCreateMemberCoApplicantDocumentAutoLoanResponseReset),
		call(onFetchMemberAutoLoan),
		call(onFetchMemberAutoLoanResponseReset),
		call(onGetParticularAutoLoanDetails),
		call(onGetParticularAutoLoanResponseReset),
		call(onApproveMemberAutoLoan),
		call(onApproveMemberAutoLoanResponseReset),
		call(onRevertMemberAutoLoan),
		call(onrevertMemberAutoLoanResponseReset),
		call(ondeleteMemberAutoLoanResponseReset),
		call(onDeleteMemberAutoLoan),
		call(onCreateMemberAutoLoanResponseReset),
		call(onCreateMemberAutoLoanDetails),
		call(onGetAllDealerList),
		call(onGetAllDealerListReset),
		call(onCreateMemberAutoLoanIndexDetails),
		call(onCreateMemberAutoLoanIndexResponseReset),
		call(onCreateMemberVehicleAutoLoanDetails),
		call(onCreateMemberVehicleAutoLoanResponseReset),
		call(onCreateMemberVehicleDocumentAutoLoanDetails),
		call(onCreateMemberVehicleDocumentAutoLoanResponseReset),
		call(onCreateMemberBusinessAutoLoanDetails),
		call(onCreateMemberBusinessAutoLoanResponseReset),
		call(onCreateMemberBusinessImageAutoLoanDetails),
		call(onCreateMemberBusinessImageAutoLoanResponseReset),
		call(onGetPermantPincodeList),
		call(onGetPermantPincodeListReset),
		call(onCheckAutoLoanMandatory),
		call(onCheckAutoLoanMandatoryResponseReset),
		call(onUpdataeMemberAutoLoanIndexResponseReset),
		call(onUpdateMemberAutoLoanIndexDetails),
	]);
}
